import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import AppShell from "@/components/AppShell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import InventoryPage from "@/pages/InventoryPage";
import SubscriptionsPage from "@/pages/SubscriptionsPage";
import TicketsPage from "@/pages/TicketsPage";
import TicketDetailPage from "@/pages/TicketDetailPage";
import AuditsPage from "@/pages/AuditsPage";
import InvoicesPage from "@/pages/InvoicesPage";
import VendorsPage from "@/pages/VendorsPage";
import CompaniesPage from "@/pages/CompaniesPage";
import EmployeePortalPage from "@/pages/EmployeePortalPage";
import UsersPage from "@/pages/UsersPage";
import ReportsPage from "@/pages/ReportsPage";

const HomeRoute = () => {
  const u = JSON.parse(localStorage.getItem("pgac_user") || "null");
  if (u?.role === "employee") return <EmployeePortalPage />;
  return <DashboardPage />;
};

const PrivateLayout = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 data-label">Authenticating…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell><Outlet /></AppShell>;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<PrivateLayout />}>
              <Route path="/" element={<HomeRoute />} />
              <Route path="/inventory" element={<InventoryPage />} />
              <Route path="/subscriptions" element={<SubscriptionsPage />} />
              <Route path="/audits" element={<AuditsPage />} />
              <Route path="/invoices" element={<InvoicesPage />} />
              <Route path="/vendors" element={<VendorsPage />} />
              <Route path="/tickets" element={<TicketsPage />} />
              <Route path="/tickets/:id" element={<TicketDetailPage />} />
              <Route path="/companies" element={<CompaniesPage />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/portal" element={<EmployeePortalPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
